<template>
  <div class="content-container">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <agentVendorShop @select="selectHandler" />
      <el-form-item label="所在城市">
        <el-select v-model="formInline.shopCity" placeholder="请选择">
          <el-option
            v-for="(item, index) in CITY_ENUM"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="创建起止时间">
        <el-date-picker
          v-model="formInline.createtime"
          type="daterange"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>-->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
        <el-button type="primary" icon="el-icon-plus" @click="onAdd"
          >新增</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-delete"
          @click="onBatchDelete"
          :disabled="multipleSelection.length === 0"
          >批量删除</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <!-- <el-table-column prop="shopid" label="门店id"></el-table-column>-->
      <el-table-column prop="shopImageUrl" width="105px" label="门店图">
        <template slot-scope="scope">
          <img
            v-if="scope.row.shopImageUrl"
            width="100px"
            height="100px"
            style="cursor:pointer"
            :src="'/api/shared/getImage?ossFileKey=' + scope.row.shopImageUrl"
            @click="showBig(scope.row.shopImageUrl)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="shopName" label="门店名"></el-table-column>
      <!-- <el-table-column prop="shopCity" label="所在城市"></el-table-column> -->
      <el-table-column prop="shopAddress" label="地址"></el-table-column>
      <el-table-column prop="shopTelephone" label="联系电话"></el-table-column>

      <!-- <el-table-column label="经纬度">
        <template slot-scope="scope">
          <div>
            {{ `[${scope.row.shopLongitude},${scope.row.shopLatitude}]` }}
          </div>
        </template>
      </el-table-column>-->
      <el-table-column label="商家名称">
        <template slot-scope="scope">
          <div>{{ filterShopOwnerName(scope.row.shopOwner) }}</div>
        </template>
      </el-table-column>

      <el-table-column label="是否下线">
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.shopOffline">下线</el-tag>
          <el-tag type="success" v-else>上线</el-tag>
        </template>
      </el-table-column>
      
      <el-table-column label="是否可约">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.canReserve">可约 ({{ scope.row.reserveMinutes }}分钟)</el-tag>
          <el-tag type="warning" v-else>不可</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="运营时间">
        <template slot-scope="scope">
          <div>{{ scope.row.shopOpenTime }}~{{ scope.row.shopCloseTime }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="shopDescription" label="描述"></el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          <div>{{ scope.row.createtime | formatDateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="修改时间">
        <template slot-scope="scope">
          <div>{{ scope.row.modifiedtime | formatDateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="230">
        <template slot-scope="scope">
          <el-button type="text" @click="handleDelete(scope.row.shopid)"
            >删除</el-button
          >
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <template v-if="userType === 'admin' || userType === 'vendor'">
            <el-button type="text">
              <router-link
                tag="div"
                :to="{ name: 'machine', query: { shopid: scope.row.shopid } }"
                >查看机器</router-link
              >
            </el-button>
            <el-button type="text" @click="handleStatistic(scope.row.shopid)"
              >查看统计</el-button
            >
            <el-button
              type="text"
              @click="setEnableMachines(scope.row.shopid, false)"
              >一键停用</el-button
            >
            <el-button
              type="text"
              @click="setEnableMachines(scope.row.shopid, true)"
              >一键启用</el-button
            >
          </template>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    ></el-pagination>

    <el-dialog title="查看图片" :visible.sync="imageBigVisible" width="900px">
      <el-carousel trigger="click" height="640px">
        <img class="movie-img" :src="currentImageUrl" alt srcset />
      </el-carousel>
      <span slot="footer" class="dialog-footer">
        <el-button @click="imageBigVisible = false">取 消</el-button>
        <el-button type="primary" @click="imageBigVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <EditDialog
      v-if="isDialogShow"
      @closeForm="closeForm"
      @handleUpdate="onSubmit"
      :isCreate="isCreate"
      :shopInfo="shopInfo"
    />
  </div>
</template>

<script>
import agentVendorShop from "@/components/layout/agentVendorShop";

import enumObject from "../../plugins/enum";
import EditDialog from "./components/editDialog";
//import { mapGetters } from "vuex";
export default {
  components: {
    EditDialog,
    agentVendorShop
  },
  data() {
    return {
      formInline: {
        //projectid: "",
        shopCity: "",
        createtime: "",
        shopOwner: "",
        agentid: "",
        //vendorid: "",

        agentName: "",
        shopid: "",
        vendorName: "",
        shopName: ""
      },
      tableData: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      multipleSelection: [],
      //vendorEntityList: [],
      CITY_ENUM: enumObject.CITY_ENUM,
      imageBigVisible: false,
      isDialogShow: false,
      isCreate: true,
      shopInfo: null,
      currentImageUrl: "",
      // vendorList: [],
      // agentList: [],

      agentListForPrompt: [],
      vendorListForPrompt: [],
      shopListForPrompt: [],
      userType: this.$getUserType()
    };
  },

  methods: {
    selectHandler(x) {
      console.log("selectHandler", x);
      this.formInline.agentid = x.selectedAgent.agentid;
      this.formInline.shopOwner = x.selectedVendor.vendorid;
      this.formInline.shopid = x.selectedShop.shopid;
    },
    onSubmit() {
      let queryModel = {
        agentid: this.formInline.agentid,
        //vendorid: this.formInline.vendorid,
        shopid: this.formInline.shopid,
        //projectid: this.formInline.projectid,
        shopName: this.formInline.shopName,
        shopCity: this.formInline.shopCity,
        shopOwner: this.formInline.shopOwner,
        createtimeFrom: Array.isArray(this.formInline.createtime)
          ? this.$ToDateString(this.formInline.createtime[0])
          : null,
        createtimeTo: Array.isArray(this.formInline.createtime)
          ? this.$ToDateString(this.formInline.createtime[1])
          : null,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      this.$axios(this.$urlMapping["查询门店"], {
        data: queryModel
      }).then(result => {
        console.log(result.data);
        this.tableData = result.data.map(ele => ele.shopInfoEntity);
        console.log(this.tableData);

        this.vendorEntityList = result.data.map(ele => ele.vendorEntity);

        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    queryAgent() {
      this.$axios(this.$urlMapping["查询代理商"], {
        data: {}
      }).then(result => {
        this.agentList = [{ agentid: "", agentName: "全部" }, ...result.data];
      });
    },
    queryVendor(agentid) {
      this.$axios(this.$urlMapping["查询加盟商"], {
        data: { agentid: agentid }
      }).then(result => {
        this.vendorList = [
          { vendorid: "", vendorName: "全部" },
          ...result.data
        ];
      });
    },

    handleChangeAgent() {
      this.formInline.shopOwner = this.formInline.shopid = "";
      this.vendorList = [];
      this.shopList = [];
      if (this.formInline.agentid != "") {
        this.queryVendor(this.formInline.agentid);
      }
    },
    showBig(url) {
      console.log(url);
      if (url) {
        this.currentImageUrl = "/api/shared/getImage?ossFileKey=" + url;
        this.imageBigVisible = true;
      }
    },
    handleChangeVendor() {},

    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSubmit();
    },
    onAdd() {
      this.shopInfo = null;
      this.isCreate = true;
      this.isDialogShow = true;
    },
    handleDelete(shopid) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let shopIDs = [shopid];
        this.$axios(this.$urlMapping["删除门店"], {
          data: {
            shopIDs
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.onSubmit();
        });
      });
    },
    handleEdit(shopInfo) {
      console.log(shopInfo);
      this.shopInfo = shopInfo;
      this.isCreate = false;
      this.isDialogShow = true;
    },
    closeForm() {
      this.isDialogShow = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onBatchDelete() {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let shopIDs = this.multipleSelection.map(ele => ele.shopid);
        this.$axios(this.$urlMapping["删除门店"], {
          data: {
            shopIDs
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.onSubmit();
        });
      });
    },
    filterShopOwnerName(vendorid) {
      let item = this.vendorEntityList.find(
        ele => ele && ele.vendorid === vendorid
      );
      if (item) {
        return item.vendorName;
      } else {
        return "无效的vendor【" + vendorid + "】";
      }
    },
    handleStatistic(shopid) {
      this.$router.push({
        name: "shopOrderStatic",
        query: {
          shopid
        }
      });
    },
    setEnableMachines(shopid, enable) {
      this.$axios(this.$urlMapping["查询机器"], {
        data: { machineInShopid: shopid }
      }).then(result => {
        let all = result.data.map(ele => ele.machineExtendModel);
        let disableMachine = all
          .filter(ele => ele.machineEnable == false)
          .map(x => x.machineid);
        let enabledMachine = all
          .filter(ele => ele.machineEnable == true)
          .map(x => x.machineid);
        let machineids = [];
        if (enable) {
          machineids = disableMachine;
        } else {
          machineids = enabledMachine;
        }

        console.log(disableMachine);
        console.log(enabledMachine);
        let msg =
          "总机器数:" +
          all.length +
          ", 停用机器数:" +
          disableMachine.length +
          ", 启用机器数:" +
          enabledMachine.length +
          "。是否将该店所有机器设置为" +
          (enable ? "【启用】？" : "【停用】？");
        this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(x => {
            console.log(x);
            //console.log("enabledMachine");
            //console.log(enabledMachine);

            this.$axios(this.$urlMapping["批量停启机器"], {
              data: {
                enable: enable,
                machineids: machineids
              }
            }).then(() => {
              this.$notifySuccess();
            });
          })
          .catch(x => {
            console.log(x);
          });

        console.log(msg);
      });
    }
  },
  // async mounted() {
  //   if (this.userType === "admin") {
  //     await this.$axios(this.$urlMapping["查询加盟商"], {
  //       data: {}
  //       // eslint-disable-next-line no-unused-vars
  //     }).then(result => {
  //       this.vendorsList = [
  //         { vendorName: "全部", vendorid: "", vendorContact: "" },
  //         ...result.data
  //       ];
  //     });
  //   }
  //   this.formInline.shopOwner = this.$route.query.vendorid;
  //   await this.onSubmit();
  // }
  mounted() {
    this.formInline.shopOwner = this.$route.query.shopOwner;
    this.onSubmit();
  }
};
</script>

<style lang="less" scoped></style>
